import { getItemFromWebStorage, setItemOnWebStorage } from '@ynap/web-storage-utils';
import { v4 as uuid } from 'uuid';

export const getVisitorId = () => {
    if (typeof window !== 'undefined') {
        const visitorKey = 'opt_fs_visitorId';
        let id = getItemFromWebStorage('localStorage', visitorKey);

        if (!id) {
            id = uuid();
            setItemOnWebStorage('localStorage', visitorKey, id);
        }

        return id;
    }
};